import { Emoji as BaseEmoji } from "emoji-picker-react";

import { getPinnedEmojiUrl, isEmojiCodepoint } from "~/components/ui/emoji-url";

interface EmojiProps {
  unified: string;
  size?: number;
  lazyLoad?: boolean;
}

export function Emoji({ unified, size, lazyLoad }: EmojiProps) {
  if (!isEmojiCodepoint(unified)) {
    return null;
  }

  return <BaseEmoji unified={unified} size={size} lazyLoad={lazyLoad} getEmojiUrl={getPinnedEmojiUrl} />;
}
